import { render, staticRenderFns } from "./ExpulsionOrderView.vue?vue&type=template&id=75a40bd4&"
import script from "./ExpulsionOrderView.vue?vue&type=script&lang=ts&"
export * from "./ExpulsionOrderView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports